export enum QuestionMaturity {
  Answered = 'Answered',
  Validated = 'Validated',
  NotAnswered = 'Unanswered',
}

export enum WedoMaturity {
  Open = 'Open',
  InProgress = 'In Progress',
  Done = 'Done',
}

/**
 * The item that is used to display the maturity in a header/pipeline
 *
 * @description Expects a type T that will be the type of id of this item
 */
export interface MaturityItem<T extends string> {
  /**
   * The unique identifier of this item
   */
  id: T
  /**
   * The number of items with this maturity
   */
  total: number
  /**
   * Optional class names to be added
   */
  class?: string
  /**
   * True if this maturity is selected or active
   */
  active: boolean
  /**
   * The name or label of this maturity
   */
  text: string
  /**
   * The icon for this maturity
   * @description It is used in mobile breakpoints
   */
  icon: string
  /**
   * The background color
   */
  bgColor: string
  /**
   * The text color
   */
  textColor: string
}
